import React from 'react';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import { connect } from 'react-redux';
import _ from 'lodash';

import { closePersonForm, savePerson } from '../../store/modules/person';
import mergeStates from '../../helpers/mergeStates';
import FormAddress from '../FormAddress/FormAddress';
import FormContactDetail from '../FormContactDetail/FormContactDetail';
import CompanyPicker from '../../components/CompanyPicker/CompanyPicker';

import SimplWysiwyg from '../SimplWysiwyg/SimplWysiwyg';
import FormTasks from '../FormTasks/FormTasks';
import SimplDatepicker from '../SimplDatepicker/SimplDatepicker';
import FormFileUpload from '../FormFileUpload/FormFileUpload';
import { RaisedButton } from 'material-ui';
import { simplImageUrl } from '../../api/simplApi';

const mapActionCreators = {
  savePerson,
  closePersonForm,
};

const mapStateToProps = state => ({
  person: state.person.persons[state.person.formTarget],
  fetching: state.person.fetching,
  open: state.person.formOpen,
  formTarget: state.person.formTarget,
  login: state.login.isAuthenticated,
  simplAccount: state.login.simplAccount,
  files: _.filter(
    _.pick(
      state.file.files,
      state.person.persons[state.person.formTarget]
        ? state.person.persons[state.person.formTarget].files
        : {},
    ),
    ['deleted_at', null],
  ),
  tasks: _.pick(
    state.task.tasks,
    state.person.persons[state.person.formTarget]
      ? state.person.persons[state.person.formTarget].tasks
      : null,
  ),
});

const initialState = {
  name: '',
  id: null,
  address: {},
  company_ids: [],
  contactDetails: [
    {
      value: '',
      type: 'mobile',
      note: '',
    },
  ],
  birthday: null,
  avatar_id: '',
  meta: {
    notes: '',
  },
  files: [],
  tasks: [],
};

class FormPerson extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
    this.receivedProps = false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open === false && nextProps.open === true) {
      setTimeout(() => this.focus(), 150);

      if (window.simplPreselection.company !== null) {
        this.setState({
          company_ids: [window.simplPreselection.company],
        });
        window.simplPreselection.company = null;
      }
    }

    if (
      typeof nextProps.formTarget !== 'undefined' &&
      nextProps.formTarget !== null &&
      this.receivedProps === false
    ) {
      if (
        typeof nextProps.person !== 'undefined' &&
        nextProps.person !== null
      ) {
        this.setState(_.omit(nextProps.person, ['tasks', 'files']));

        const meta = {};

        _.forOwn(nextProps.person.meta, (value, key) => {
          meta[key] = value.value;
        });

        this.setState({ company_ids: nextProps.person.companies });

        this.setState({ meta });

        if (typeof nextProps.person.contact_details !== 'undefined') {
          this.setState({ contactDetails: nextProps.person.contact_details });
        }

        if (typeof nextProps.person.addresses !== 'undefined') {
          this.setState({ address: nextProps.person.addresses[0] });
        }

        this.receivedProps = true;
      }
    }

    if (nextProps.tasks !== null) {
      if (
        Object.keys(this.props.tasks).length !==
        Object.keys(nextProps.tasks).length
      ) {
        const tasks = [];

        _.forOwn(nextProps.tasks, task => {
          if (typeof task !== 'string') {
            tasks.push(task);
          }
        });

        this.setState({
          tasks,
        });
      }
    }

    if (this.state.files.length === 0) {
      this.setState({
        files: Object.keys(nextProps.files).map(key => nextProps.files[key]),
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    const omit = ['savePerson', 'closePersonForm'];

    if (
      JSON.stringify(_.omit(nextProps, omit)) !==
      JSON.stringify(_.omit(this.props, omit))
    ) {
      return true;
    }

    return false;
  }

  focus = () => {
    if (this.primaryInput && this.primaryInput !== null) {
      this.primaryInput.focus();
    }
  };

  onTextChange = content => {
    const nextState = mergeStates(null, this.state, ['meta', 'notes'], content);

    this.setState(nextState);
  };

  resetState = () => {
    this.setState(initialState);
    this.receivedProps = false;
  };

  save = () => {
    // console.log('saving!', this.state);
    this.props.savePerson(this.state);
    this.resetState();
    this.props.closePersonForm();
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);
  };

  handleDate = date => {
    const nextState = mergeStates(null, this.state, 'meta.date_of_birth', date);
    this.setState(nextState);
  };

  addContactDetail = e => {
    const nextState = _.cloneDeep(this.state);

    if (e.button !== 0) {
      // abort on not left click
      return;
    }

    // note for later: converting collection to array is done by
    // nextState.contact_details = _.values(nextState.contact_details);

    nextState.contactDetails.push({
      id: `new_${Date.now()}`,
      value: '',
      type: 'email',
      note: '',
    });

    this.setState(nextState);
  };

  applyContactDetailChange = contactDetail => {
    const nextState = _.cloneDeep(this.state);

    for (let i = nextState.contactDetails.length - 1; i >= 0; i--) {
      if (contactDetail.id === nextState.contactDetails[i].id) {
        nextState.contactDetails[i] = contactDetail;
      }
    }

    this.setState(nextState);
  };

  handleContactDetailDeletion = contactDetail => {
    const nextState = _.cloneDeep(this.state.contactDetails);

    for (let i = nextState.length - 1; i >= 0; i--) {
      if (contactDetail.id === nextState[i].id) {
        nextState.splice(i, 1);
      }
    }

    this.setState({ contactDetails: nextState });
  };

  renderContactDetails = () => {
    // this.state.contact_details are the exact outcome from the server,
    // they will get transformed into an array using this.state.contactDetails

    const sortedDetails = _.sortBy(this.state.contactDetails, [
      'sortedByType',
      'created_at',
    ]);

    return sortedDetails.map(detail => (
      <FormContactDetail
        key={`contact_detail_form_${detail.id}`}
        contactDetail={detail}
        onChange={contactDetail => {
          this.applyContactDetailChange(contactDetail);
        }}
        onDelete={contactDetail => {
          this.handleContactDetailDeletion(contactDetail);
        }}
      />
    ));
  };

  render() {
    const props = this.props;

    const opened = typeof props.open !== 'undefined' ? props.open : false;

    let buttonText = 'Erstellen';
    if (this.state.id !== null) {
      buttonText = 'Speichern';
    }

    const actions = [
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          this.resetState();
          props.closePersonForm();
        }}
      />,
      <RaisedButton
        style={{ marginLeft: 10 }}
        label={buttonText}
        primary
        disabled={this.state.name.trim().length === 0}
        onMouseDown={() => this.save()}
      />,
    ];

    let title = 'Neuen Kontakt erstellen';
    if (this.state.id !== null) {
      title = `"${this.state.name}" bearbeiten`;
    } else if (this.state.name.length) {
      title = `"${this.state.name}" erstellen`;
    }

    return (
      <Dialog
        title={title}
        actions={actions}
        modal={false}
        open={opened}
        autoScrollBodyContent
        className="form modal-center"
        contentClassName="form-container form-container--person"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body"
      >
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <label className="simpl-label" htmlFor="name">
                  Name
                </label>
              </div>
              <div className="col-xs-12 col-sm-6">
                <input
                  name="name"
                  required
                  value={this.state.name}
                  onChange={e => this.handleChange(e)}
                  ref={input => {
                    this.primaryInput = input;
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <label className="simpl-label" htmlFor="meta.salutation">
                  Titel
                </label>
              </div>
              <div className="col-xs-12 col-sm-6">
                <input
                  name="meta.salutation"
                  value={this.state.meta.salutation}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <label className="simpl-label" htmlFor="meta.salutation">
                  Geschlecht
                </label>
              </div>
              <div className="col-xs-12 col-sm-6">
                <RadioButtonGroup
                  className="radiogroup radiogroup-horizontal radiogroup-horizontal-double"
                  name="meta.gender"
                  onChange={e => this.handleChange(e)}
                  defaultSelected={this.state.meta.gender}
                >
                  <RadioButton value="male" label="männlich" />
                  <RadioButton value="female" label="weiblich" />
                </RadioButtonGroup>
              </div>
            </div>
          </div>
          <div className="col-md-1" />
          <div className="col-xs-12 col-md-3">
            <FormFileUpload
              files={[]}
              onUpdate={id => {
                this.setState({ avatar_id: id });
              }}
              avatar
              avatarUrl={
                this.state.avatar_id !== null && this.state.avatar_id.length
                  ? simplImageUrl(
                      this.props.simplAccount,
                      this.state.avatar_id,
                      128,
                      128,
                      'crop',
                    )
                  : ''
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="start-time">
              Geburtstag
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <SimplDatepicker
              defaultValue={this.state.meta.date_of_birth}
              dateFormat="DD.MM.YYYY"
              dateFormatSubmit="DD. MM. YYYY"
              onChange={date => {
                this.handleDate(date);
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="company_ids">
              Unternehmen
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <CompanyPicker
              name="company_ids"
              default={this.state.company_ids}
              onChange={e => this.handleChange(e)}
              multi
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.position">
              Position
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="meta.position"
              value={this.state.meta.position}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.notes">
              Bemerkungen
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <SimplWysiwyg
              content={this.state.meta.notes}
              onUpdate={content => this.onTextChange(content)}
            />
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-xs-12">
            <h2>Kommunikation</h2>
          </div>
        </div>
        {this.renderContactDetails()}
        <div className="row">
          <div className="col-xs-12 text-center">
            <button
              className="button button--link"
              onMouseDown={e => {
                this.addContactDetail(e);
              }}
            >
              + Kommunikationsart hinzufügen
            </button>
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-xs-12">
            <h2>Anschrift</h2>
          </div>
        </div>
        <FormAddress
          value={this.state.address}
          onChange={address => {
            this.setState({ address });
          }}
        />

        <hr />

        <FormTasks
          tasks={this.state.tasks}
          onUpdate={tasks => this.setState({ tasks })}
        />

        <hr />

        <FormFileUpload
          files={this.state.files}
          onUpdate={files => this.setState({ files })}
        />
      </Dialog>
    );
  }
}
FormPerson.propTypes = {
  savePerson: PropTypes.func.isRequired,
  closePersonForm: PropTypes.func.isRequired,
  formTarget: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]),
  open: PropTypes.bool,
  tasks: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  files: PropTypes.array, // eslint-disable-line react/no-unused-prop-types
  person: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  simplAccount: PropTypes.string,
};
export default connect(mapStateToProps, mapActionCreators)(FormPerson);



// WEBPACK FOOTER //
// ./src/components/FormPerson/FormPerson.js